export default {"src":"/_next/static/media/SAGE.f23f24c5.svg","height":18,"width":18};